import { ISelectableRealestate } from "src/stores/RealestateStore";

export const MINIMUM_CHARACTERS_FOR_SEARCH = 3;

// IT2: a realestate of a consolidation (Mandant) points to it with its consolidationid.
export const belongsToConsolidation = (realestate: ISelectableRealestate) => Boolean(realestate.consolidationid);

const matchesSearchQuery = (realestate: ISelectableRealestate, normalizedSearchQuery: string) =>
    realestate.name.toLowerCase().includes(normalizedSearchQuery) ||
    realestate.number.toLowerCase().includes(normalizedSearchQuery);

// Realestates that can still be picked: not selected yet and matching the search by name or number.
export const getDisplayedRealestates = (
    realestates: ISelectableRealestate[],
    selectedRealestateIds: string[],
    searchQuery: string
) => {
    const selectedRealestateIdSet = new Set(selectedRealestateIds);
    const normalizedSearchQuery = searchQuery.trim().toLowerCase();
    const isSearchActive = normalizedSearchQuery.length >= MINIMUM_CHARACTERS_FOR_SEARCH;

    return realestates.filter(
        (realestate) =>
            !selectedRealestateIdSet.has(realestate.id) &&
            (!isSearchActive || matchesSearchQuery(realestate, normalizedSearchQuery))
    );
};

// A click on a realestate of a consolidation adds only this realestate.
// A click on a consolidation adds it together with its realestates that are not selected yet.
// Rimo has no consolidations, so a click there always adds only the clicked realestate.
export const getRealestatesToAdd = (
    clickedRealestate: ISelectableRealestate,
    realestates: ISelectableRealestate[],
    selectedRealestateIds: string[]
) => {
    if (belongsToConsolidation(clickedRealestate)) {
        return [clickedRealestate];
    }

    const realestatesOfConsolidation = realestates.filter(
        (realestate) =>
            realestate.consolidationid === clickedRealestate.id && !selectedRealestateIds.includes(realestate.id)
    );

    return [clickedRealestate, ...realestatesOfConsolidation];
};
